import React, {
  ElementType,
  FunctionComponent,
  PropsWithChildren,
} from 'react';

import {
  ContainerProps,
  default as MuiContainer,
} from '@mui/material/Container';

const Container: FunctionComponent<ContainerProps<ElementType>> = (
  props: PropsWithChildren<ContainerProps<ElementType>>
) => {
  return <MuiContainer {...props} />;
};

export default Container;
